import React from 'react'
import Link from 'gatsby-link'
import styles from './NavBar.module.css'

function NavBar({ linkable = false } = {}) {
  return (
    <nav className="pv3" style={{ backgroundColor: '#0F0B0C' }}>
      <h1 className="ph3 ph4-ns db mv0 ttl" style={{ color: '#E8E8E8' }}>
        {linkable
          ? (<Link className={styles.title} style={{ color: '#E8E8E8' }} to="/">Notebook</Link>)
          : 'Notebook'
        }
      </h1>
    </nav>
  )
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx